export { default } from './SliderControlArrows';
